import { compose } from 'recompose';
import PurchaseReturnVatReport from './PurchaseReturnVatReport';
import apiInterceptor from '../../../api/interceptor';
import { purchaseReturnVatApi } from '../../common/base.api';

const composedSalesVatReport = compose(apiInterceptor({ ...purchaseReturnVatApi }))(PurchaseReturnVatReport);

export default composedSalesVatReport;
